export const TALENTIA_PERSON_URL = 'https://hcmcloudfr.talentiasw.com/hracted/readonly/1000003;PERSON_ID='

export enum StaffHQTransition {
  INITIALISE = 'initialise',
  CREATE_AZURE = 'create_azure',
  ACTIVATE = 'activate',
  REACTIVATE = 'reactivate',
  DEACTIVATE = 'deactivate',
  ERROR = 'error',
  REVERT = 'revert',
}

export enum StaffHQState {
  CREATED = 'created',
  INITIALISED = 'initialised',
  CREATED_AZURE = 'created_azure',
  ACTIVE = 'active',
  INACTIVE = 'inactive',

  ERROR_INITIALISING = 'error_initialising',
  ERROR_AZURE = 'error_azure',
  ERROR_TALENTIA = 'error_talentia',
}
export const STAFF_HQ_STATES = [
  { value: StaffHQState.CREATED, label_en: 'Created', label_fr: 'Créé', severity: 'info' },
  { value: StaffHQState.INITIALISED, label_en: 'Initialised', label_fr: 'Initialisé', severity: 'info' },
  { value: StaffHQState.CREATED_AZURE, label_en: 'Created (Azure)', label_fr: 'Créé (Azure)', severity: 'warn' },
  { value: StaffHQState.ACTIVE, label_en: 'Active', label_fr: 'Actif', severity: 'success' },
  { value: StaffHQState.INACTIVE, label_en: 'Inactive', label_fr: 'Inactif', severity: 'warn' },

  { value: StaffHQState.ERROR_INITIALISING, label_en: 'Error (Initialising)', label_fr: 'Erreur (Initialiser)', severity: 'danger' },
  { value: StaffHQState.ERROR_AZURE, label_en: 'Error (Azure)', label_fr: 'Erreur (Azure)', severity: 'danger' },
  { value: StaffHQState.ERROR_TALENTIA, label_en: 'Error (Talentia)', label_fr: 'Erreur (Talentia)', severity: 'danger' },
]

export enum StaffHQAccompanyStatus {
  SINGLE = 'single-position',
  ACCOMPANIED = 'accompanied-position',
}
export const STAFF_HQ_ACCOMPANY_STATUSES = [
  { value: StaffHQAccompanyStatus.SINGLE, label_en: 'Single position', label_fr: 'Position non accompagnée' },
  { value: StaffHQAccompanyStatus.ACCOMPANIED, label_en: 'Accompanied position', label_fr: 'Position accompagnée' },
]
